var _path, _path2, _path3, _path4, _path5, _rect;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAgendaActive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 3.59359V2.26025V3.59359ZM10 3.59359V4.92692V3.59359ZM10 3.59359H7H10ZM2 7.59359V13.5936C2 13.9472 2.14048 14.2863 2.39052 14.5364C2.64057 14.7864 2.97971 14.9269 3.33333 14.9269H12.6667C13.0203 14.9269 13.3594 14.7864 13.6095 14.5364C13.8595 14.2863 14 13.9472 14 13.5936V7.59359H2Z",
    stroke: "#6AA287",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 7.59375V4.92708C2 4.57346 2.14048 4.23432 2.39052 3.98427C2.64057 3.73423 2.97971 3.59375 3.33333 3.59375H4.66667",
    stroke: "#6AA287",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.66663 2.26025V4.92692V2.26025Z",
    fill: "#717A97"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.66663 2.26025V4.92692",
    stroke: "#6AA287",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14 7.59375V4.92708C14 4.57346 13.8596 4.23432 13.6095 3.98427C13.3595 3.73423 13.0203 3.59375 12.6667 3.59375H12.3334",
    stroke: "#6AA287",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 2.16162,
    y: 7.68896,
    width: 11,
    height: 7,
    fill: "#6AA287"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgendaActive);
export default __webpack_public_path__ + "static/media/agenda-active.f5d9fe5755d5e22cfb79aa6ba19f320a.svg";
export { ForwardRef as ReactComponent };